export default __webpack_public_path__ + "static/Ananti-c2a4799f79c7df489d40fe8b14f76da2.svg";